const filterMenuData = (menuData = [], filterValue = '') => {
  if (!Array.isArray(menuData) || menuData.length === 0 || !filterValue) {
    return menuData;
  }

  return menuData?.filter(item => item?.includedInMenus?.includes(filterValue));
};

export default filterMenuData;
